import React, { ReactNode } from 'react';

import { HEIGHTS, WIDTHS } from '../constants';

interface LeftNavMenuProps {
    accountDropdown?: JSX.Element;
    logo: JSX.Element;
    menuItems: ReactNode;
}

export const LeftNavMenu = ({
    accountDropdown,
    logo,
    menuItems,
}: LeftNavMenuProps): JSX.Element => (
    <nav
        className="flex flex-col h-screen justify-start flex-none fixed top-0 left-0 z-10"
        style={{ width: WIDTHS.LEFT_NAV }}
    >
        <div
            className="pt-10 flex justify-center border-r border-tertiary-200"
            style={{
                paddingBottom: HEIGHTS.NAV_MENU_ICON_BOTTOM_PADDING,
                // Using an explicit height here prevents a layout bug in Safari
                height: HEIGHTS.NAV_MENU_ICON_CONTAINER,
            }}
        >
            <div className="flex-none">{logo}</div>
        </div>
        {menuItems}
        {accountDropdown && (
            <div className="flex-grow border-r border-tertiary-200 flex flex-col justify-end">
                {accountDropdown}
            </div>
        )}
    </nav>
);
